// extracted by mini-css-extract-plugin
export var baseButton = "_v5-0";
export var controlsArrowKeys = "_v5-1";
export var controlsResetButton = "_v5-2";
export var lightGameButton = "_v5-4 _v5-0";
export var playAgainButton = "_v5-5 _v5-0";
export var startGameButton = "_v5-3 _v5-0";